'use client';

import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export interface FilterChip {
  key: string;
  label: string;
  onRemove: () => void;
}

export function FilterChipBar({
  chips,
  onClearAll,
  className,
}: {
  chips: FilterChip[];
  onClearAll?: () => void;
  className?: string;
}) {
  const { t } = useTranslation();
  if (!chips.length) return null;
  return (
    <div className={cn('flex flex-wrap items-center gap-2 px-3 py-2', className)}>
      {chips.map(({ key, label, onRemove }) => (
        <span
          key={key}
          className="inline-flex max-w-full items-center gap-1 rounded-md bg-muted px-2 py-0.5 text-xs"
        >
          <span className="min-w-0 break-words">{label}</span>
          <button
            type="button"
            className="flex size-10 shrink-0 items-center justify-center rounded hover:bg-background lg:size-5"
            aria-label={t('search.activeFilters.remove', { label })}
            onClick={onRemove}
          >
            <X className="size-3" aria-hidden />
          </button>
        </span>
      ))}
      {chips.length >= 2 && onClearAll && (
        <button
          type="button"
          className="min-h-10 text-xs text-muted-foreground underline hover:text-foreground lg:min-h-6"
          onClick={onClearAll}
        >
          {t('search.activeFilters.clearAll')}
        </button>
      )}
    </div>
  );
}
